import { API_MAP } from '@common/api/api-map';
export const keycloakAipMap = new Map([
    [API_MAP.MEMBER_EDIT_INFO, 'member'],
    [API_MAP.MEMBER_EDIT_PWD, 'member'],
    [API_MAP.USER_INFO, 'member'],
    [API_MAP.MEMBER_ADDRESS_LIST, 'member'],
    [API_MAP.SEND_CAPTCHA, 'member'],
    [API_MAP.CHECK_CAPTCHA, 'member'],
    [API_MAP.REGISTER, 'member'],
    [API_MAP.SECONDARY_REGISTER, 'member'],
    [API_MAP.SEND_EMAIL_CAPTCHA_BY_MEMBER_EXAMINE, 'member'],
    [API_MAP.CREATE_MEMBER_EXAMINE, 'member'],
    [API_MAP.GET_MEMBER_EXAMINE_STATUS, 'member'],
    [API_MAP.CHECK_MOBILE, 'member'],
    [API_MAP.GET_ORDER_RECORD_DETAIL, 'member'],
    [API_MAP.GET_HISTORY_ORDER_DETAIL, 'member'],
    [API_MAP.ORDER_STATUS_NUM, 'member'],
    [API_MAP.GET_COLLECT_LIST, 'member'],
    [API_MAP.DELETE_COLLECT, 'member'],
    [API_MAP.FAVORITE, 'member'],
    [API_MAP.DELFAVORITE, 'member'],
    [API_MAP.WAIT_EVALUATION_LIST, 'member'],
    [API_MAP.EVALUATED_LIST, 'member'],
    [API_MAP.ADD_EVALUATION, 'member'],
    [API_MAP.APPLY_AFTER_SALES_LIST, 'member'],
    [API_MAP.AFTER_SALES_LIST, 'member'],
    [API_MAP.ORDER_LIST, 'member'],
    [API_MAP.HISTORY_ORDER_LIST, 'member'],
    [API_MAP.POINTS_RECORD_LIST, 'member'],
    [API_MAP.ORDER_ITEM_PRODUCT, 'member'],
    [API_MAP.RECEIVE_COUPON_LIST, 'member'],
    [API_MAP.RECEIVE_COUPON, 'member'],
    [API_MAP.PRODUCT_EVALUATION, 'member'],
    [API_MAP.AFTER_SALES, 'member'],
    [API_MAP.MESSAGE_LIST, 'member'],
    [API_MAP.MESSAGE_EDTAIL, 'member'],
    [API_MAP.MESSAGE_COUNT, 'member'],
    [API_MAP.MESSAGE_READ, 'member'],
    [API_MAP.UPLOAD_PAYMENT, 'member'],
    [API_MAP.PAYMENT_VOUCHER_IMG, 'member'],
    [API_MAP.CHECKOUT_INFO, 'checkout'],
    [API_MAP.CREATE_ORDER, 'checkout'],
    [API_MAP.COUPON_LIST, 'checkout'],
    [API_MAP.VOUCHERS_LIST, 'checkout'],
    [API_MAP.CAN_USE_COUPONS, 'checkout'],
    [API_MAP.CHECKOUT_POINT_DETAIL, 'checkout'],
    [API_MAP.CHECKOUT_POINT_WRITE_OFF, 'checkout'],
    [API_MAP.CHECKOUT_ADDRESS_LIST, 'checkout'],
    [API_MAP.COUPON_CODE_CAN_USE, 'checkout'],
    [API_MAP.GET_PAY_PARAM, 'checkout'],
    [API_MAP.ASIA_PAY, 'checkout'],
    [API_MAP.CART_DETAIL, 'cart'],
    [API_MAP.CART_ADD, 'cart'],
    [API_MAP.CART_BUY_NOW_ADD, 'cart'],
    [API_MAP.CART_COUNT, 'cart'],
    [API_MAP.CART_CLEAN, 'cart'],
    [API_MAP.CART_CHANGE_GOODS_COUNT, 'cart'],
    [API_MAP.CART_SELECT_GOODS, 'cart'],
    [API_MAP.CART_DELETE_GOODS, 'cart'],
    [API_MAP.CART_SELECTED_ALL, 'cart'],
    [API_MAP.CART_DELETE_SELECTED_ALL, 'cart'],
    [API_MAP.MINI_CART, 'cart'],
    [API_MAP.CART_SELECT_PROMOTION, 'cart'],
    [API_MAP.CART_MULTI_ADD, 'cart']
]);
